module.exports = __webpack_public_path__ + "img/UT0395.0eba1eb8.png";